import { scoreStroke } from "@/lib/helpers";

export function ScoreGauge({ score, size = 220, stroke = 16, label = "Score Digital Global" }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score));
  const offset = circ - (pct / 100) * circ;
  const color = scoreStroke(score);

  return (
    <div className="relative grid place-items-center" style={{ width: size, height: size }} data-testid="dashboard-score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1.2s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-heading font-extrabold text-white leading-none" style={{ fontSize: size * 0.26 }}>
          {score == null ? "—" : score}
        </span>
        <span className="text-white/60 text-sm font-mono mt-1">/ 100</span>
      </div>
    </div>
  );
}
